import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {DashboardConfigurationModel} from './dashboard-configuration-model';
import {DashboardUrlModel} from './dashboard-url-model';
import {OrganizationData, UserInfoModel} from './user-info-model';
import {map} from 'rxjs/operators';
import {DashboardOrganizationsResponse} from './dashboard-organizations-response';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private organizations: DashboardOrganizationsResponse;

  constructor(private httpClient: HttpClient) { }

  public getOrganizations(): Observable<DashboardOrganizationsResponse> {
    if (this.organizations != null) {
      return of<DashboardOrganizationsResponse>(this.organizations);
    }

    return this.httpClient.get<DashboardOrganizationsResponse>('api/dashboards/organizations').pipe(map(x => {
      this.organizations = x;
      return x;
    }));;
  }

  public getList(): Observable<DashboardConfigurationModel[]> {
    return this.httpClient.get<DashboardConfigurationModel[]>('api/dashboards');
  }

  public getUrl(dashboardCode: string): Observable<DashboardUrlModel> {
    return this.httpClient.get<DashboardUrlModel>(`api/dashboards/${dashboardCode}/url`);
  }
}
